import { render, staticRenderFns } from "./TaskManagerIndex.vue?vue&type=template&id=55922ca2&scoped=true"
import script from "./TaskManagerIndex.vue?vue&type=script&lang=js"
export * from "./TaskManagerIndex.vue?vue&type=script&lang=js"
import style0 from "./TaskManagerIndex.vue?vue&type=style&index=0&id=55922ca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55922ca2",
  null
  
)

export default component.exports